export default "__VITE_ASSET__DZ_cov3J__"